<template>
  <sdf-link
    v-if="typeof to === 'string' && isExternalLink(to)"
    v-bind="$props"
    :href="sanitizeUrl(to)"
    target="_blank"
    external
  >
    <slot></slot>
  </sdf-link>
  <RouterLink v-else-if="to" v-slot="{ href }" :to="to" :replace="replace" custom>
    <sdf-link v-bind="$props" :href="href" :target="target" @click="handleClick">
      <slot></slot>
    </sdf-link>
  </RouterLink>
</template>

<script setup lang="ts">
import { isExternalLink } from '@pequity/shared/ui/sdf-link/link';
import { sanitizeUrl } from '@pequity/shared/ui/sdf-link/sanitization';
import type { SdfLinkSlots } from '@pequity/shared/ui/types/slots';
import type { JSX } from '@waypoint/web-components';
import { RouterLink, type RouterLinkProps, useRouter } from 'vue-router';

defineOptions({
  name: 'SdfLink',
});

type Props = RouterLinkProps & JSX.SdfLink;

const props = defineProps<Props>();
defineSlots<SdfLinkSlots>();

const router = useRouter();

const handleClick = (e: MouseEvent) => {
  if (props.target === '_blank') return;
  e.preventDefault();
  router[props.replace ? 'replace' : 'push'](props.to);
};
</script>
